import * as _ from 'lodash'
import store from '@/store'

class MapObject {
    id = 0

    identifier = 'id'

    mission_id = 0

    settings = {
        visible: true,
        icon: 'marker-blue',
    }

    object_name = 'MapObject'

    constructor(data) {
        _.forEach(data, (v, k) => {
            if (data[k] !== undefined) {
                this[k] = data[k]
            }
        })
    }

    set(values) {
        _.forEach(values, (v, k) => {
            if (values[k] !== undefined) {
                this[k] = values[k]
            }
        })
    }

    get(name) {
        return this[name]
    }

    shouldPatch() {
        return true
    }

    getLatLong() {
        return [this.latitude, this.longitude]
    }

    getAllLatLongs() {
        return [[this.latitude, this.longitude]]
    }

    getIcon() {
        return this.getSetting('icon')
    }

    setVisible(value) {
        this.updateSettingQueued('visible', value)
    }

    setIcon(value) {
        this.updateSettingQueued('icon', value)
    }

    isVisible() {
        return this.getSetting('visible')
    }

    setStale(value) {
        this.settings.stale = value
    }

    isStale() {
        return this.getSetting('stale')
    }

    isInactive() {
        const lastUserUpdate = this.getLastUpdate()

        const timeToInactive = 24 * 60 * 60 * 1000
        return lastUserUpdate >= timeToInactive
    }

    isShape() {
        return this.get('object_name') === 'MapShape'
    }

    getLastUpdate() {
        const t = window.moment.unix(new Date()) / 1000
        const lastUpdate = t - window.moment.unix(this.timestamp)._i

        return lastUpdate
    }

    updateSettingQueued(property, value) {
        const { identifier } = this
        this.settings[property] = value
        store.dispatch('mission/updateMissionSettingsQueued', {
            missionId: this.get('mission_id'),
            key: `${this.get('object_name')}_${this.get(identifier)}`,
            property,
            value,
        })
    }

    getSetting(property) {
        return this.settings[property]
    }
}

export default MapObject
